export const HTTP_ERROR_STATUSES_SKIP_LOGGING = [400, 419];
